module.exports = __webpack_public_path__ + "img/play-icon_blue.016b6066.svg";